<template>
  <div class="FaqView">
    <ShPageLayout>
      <FaqSearch />
      <FaqCategories :faq-categories="faqCategories" />
      <FaqList :faq-list-by-categories="faqListByCategories" />
    </ShPageLayout>
  </div>
</template>

<script>
import _groupBy from 'lodash.groupby';
import ShPageLayout from '@/components/Helpers/ShPageLayout';
import FaqSearch from '@/components/Faq/FaqSearch';
import FaqCategories from '@/components/Faq/FaqCategories';
import FaqList from '@/components/Faq/FaqList';

export default {
  name: 'Faq',
  components: {
    ShPageLayout,
    FaqSearch,
    FaqCategories,
    FaqList,
  },

  data() {
    return {
      selectedCategory: 'all',
    };
  },

  computed: {
    keywordSearch() {
      return this.$store.getters['settings/keywordSearchInFaqList'];
    },
    faqList() {
      const faqList = this.$store.getters['settings/faqList'];
      if (this.keywordSearch.length > 0) {
        return faqList.filter(faq => faq.keywords
          .split(',')
          .some(word => this.keywordSearch.indexOf(word) >= 0));
      }
      return faqList;
    },
    faqCategories() {
      return Object.keys(_groupBy(this.faqList, 'category'));
    },
    faqListByCategories() {
      const groupByCategory = _groupBy(this.faqList, 'category');
      return this.selectedCategory !== 'all' ? { [this.selectedCategory]: { ...groupByCategory[this.selectedCategory] } } : groupByCategory;
    },
  },

  created() {
    this.$store.dispatch('settings/getFaq');
    this.$EventBus.$on('FaqCategories/SELECT_CATEGORY', (category) => {
      this.selectedCategory = category;
    });
  },

  beforeDestroy() {
    this.$EventBus.$off('FaqCategories/SELECT_CATEGORY');
  },
};
</script>
